/* Une seule main suit la souris ; seul son geste est animé, jamais la pastille. */
.geotab-click-hand {
  display: none;
}

@media (hover: hover) and (pointer: fine) and (prefers-reduced-motion: no-preference) {
  .geotab-gap-click-cursor[data-geotab-cursor="ready"]:hover {
    cursor: none;
  }

  .geotab-click-hand[data-geotab-cursor="ready"] {
    display: block;
    position: fixed;
    z-index: 10002;
    pointer-events: none;
    width: 32px;
    height: 32px;
    background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 32 32'%3E%3Cpath fill='white' stroke='%23111' stroke-width='1.5' stroke-linejoin='round' d='M11 16V4a2 2 0 0 1 4 0v8a2 2 0 0 1 4 0v1a2 2 0 0 1 4 0v1a2 2 0 0 1 4 0v7c0 3-2 4-2 7H13c-1-3-2-4-4-6l-5-6a2 2 0 0 1 3-3l4 3Z'/%3E%3Cpath fill='none' stroke='%23111' stroke-width='1.2' stroke-linecap='round' d='M15 12v6m4-5v5m4-4v5'/%3E%3C/svg%3E") center / contain no-repeat;
    transform-origin: 13px 3px;
    filter: drop-shadow(0 1px 1px rgb(15 23 42 / 18%));
    animation: geotab-click-hand 1.6s cubic-bezier(0.45, 0, 0.2, 1) infinite;
  }
}

@keyframes geotab-click-hand {
  0%, 100% {
    transform: translate(-13px, 0) rotate(-6deg);
  }
  50% {
    transform: translate(-13px, -3px) rotate(-2deg) scale(0.94);
  }
}
